





































































































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import widgetCommon from './widgetCommon';
import { AppModule } from '@/store/modules/app';
import widgetPop from './widgetPop';
import cell from '../cell.vue';
import widget from './widgetInRecord';
import { keyBy, cloneDeep } from 'lodash';
import { childTableBatchDelete } from '@/apis/sheet';
import { autoDefault, getDynamicValue, initField } from './valueConfig';
const excludeField = ['richText', 'accessory'];
@Component({
	components: {
		cell,
	},
})
export default class extends Mixins(widgetCommon, widgetPop) {
	// @Ref() public recordForm!: recordForm;
	// @Ref() public childTable!: sheetTable;
	// @Ref() public formRef!: any;
	@Prop() public recordId!: string;
	private activeForm: any = {};
	private currentIndex: number = -1; // 当前编辑行
	private editType = 'add';
	private unwatchList: any = [];
	// 展示全部
	private isShowAll = false;
	// table展示字段
	private showFieldList: any = [];
	private get fieldList() {
		return this.item.tableFields
			.filter((item) => !excludeField.includes(item.fieldType))
			.slice(0, 3);
	}
	private get disabledJump() {
		let arr: any = [];
		if (this.currentIndex <= 0) {
			arr.push('before');
		}
		if (this.currentIndex >= this.showRecordList.length - 1) {
			arr.push('after');
		}
		return arr;
	}
	private get recordList() {
		return this.form[this.item.businessId] || [];
	}
	private get showRecordList() {
		if (this.isShowAll || !this.isReadOnly) {
			return this.recordList;
		}
		return this.recordList.slice(0, 10);
	}
	public mounted() {
		this.initField();
	}
	private jump(step) {
		if (step === -1 && this.disabledJump.includes('before')) {
			return;
		} else if (step === 1 && this.disabledJump.includes('after')) {
			return;
		}
		let index = this.currentIndex + step;
		this.rowClick(this.showRecordList[index], index);
	}
	private showStateChange(isShowAll) {
		this.isShowAll = isShowAll;
	}
	private confirm(val) {
		if (this.item.regionType === 1) {
			// 只有省的时候
			this.form[this.item.businessId] = [val.text];
		} else {
			this.form[this.item.businessId] = val;
		}
		this.changeStatus(false);
	}
	private initField() {
		if (this.isUndef(this.form[this.item.businessId])) {
			this.form[this.item.businessId] = [];
		}
	}
	private get sheetFieldMap() {
		return keyBy(this.item.tableFields, 'businessId');
	}
	private deleteRecord() {
		this.$dialog
			.confirm({
				title: '删除记录',
				message: '确定删除此记录吗？删除后不可恢复',
			})
			.then(async () => {
				const { worksheetId, businessId } = this.item;
				const childTableRecordIds = [this.activeForm.id];
				if (this.activeForm.id) {
					let res = await childTableBatchDelete({
						worksheetId,
						recordId: this.recordId,
						childTableBusinessId: businessId,
						childTableRecordIds,
					});
					if (!res.success) {
						return;
					}
				}
				this.changeStatus(false);
				this.form[this.item.businessId].splice(this.currentIndex, 1);
			});
	}
	private submit() {
		let form = this.$refs.form as any;
		let p1 = form.validate();
		p1.then(() => {
			if (this.editType === 'add') {
				this.form[this.item.businessId].push(cloneDeep(this.activeForm));
			} else {
				this.form[this.item.businessId].splice(this.currentIndex, 1, cloneDeep(this.activeForm));
			}
			this.changeStatus(false);
		});
	}
	private addRecord(data) {
		this.changeStatus(true);
		this.isShowAll = true;
		this.rowClick('', -1);
	}
	private rowClick(row, index) {
		this.changeStatus(true);
		this.activeForm = {};
		this.showFieldList = [];
		this.unwatchList.forEach((item) => {
			item();
		});
		this.unwatchList = [];
		this.currentIndex = index;
		this.$nextTick(() => {
			this.showFieldList = this.item.tableFields;
			if (row) {
				this.activeForm = cloneDeep(row);
				this.editType = 'edit';
			} else {
				this.editType = 'add';
				this.showFieldList.forEach((item) => {
					this.$set(this.activeForm, item.businessId, initField(item));
				});
			}
			// 查看记录时，不绑定公式计算
			if (this.disabled) {
				return;
			}
			this.showFieldList.forEach((item) => {
				let resWatch: any = [];
				if (item.fieldType === 'department' || item.fieldType === 'member') {
					resWatch = getDynamicValue(item, this, 'activeForm');
				} else {
					resWatch = autoDefault(item, this, 'activeForm');
				}
				if (resWatch && resWatch.length) {
					this.unwatchList.push(...resWatch);
				}
			});
		});
	}
	private beforeCreate() {
		let components = this.$options.components as any;
		components.widget = widget;
		// components.recordForm = recordForm;
		// (this.$options.components as any).widget = widget
	}
}
